import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.pruefobjekt-kopieren';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksPruefobjektKopierenEffects {

    PruefobjektKopieren$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_PRUEFOBJEKT_KOPIEREN),
        mergeMap((x: ac.PostPruefobjektKopierenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postPruefobjektKopieren(x.pruefobjektRequest).pipe(
                map((result: any) => {
                    return new ac.PostPruefobjektKopierenErfolgreichAction(result, x.pruefobjektRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostPruefobjektKopierenFehlerAction(error, x.pruefobjektRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
